import { setTerms, type TJsonQuery } from '../../../../packages/JsonQuery';
import { fetchListingOffers } from '../../services/listing/fetchListingOffers';

import type { IPublicWebV1SearchResponse } from '../../repositories/dailyrent/entities/response/PublicWebV1SearchResponse';
import type { TThunkAction } from '../../types/redux';

interface ILoadListingOffersByIdsArgs {
  baseJsonQuery: TJsonQuery;
  offerIds: number[];
  queryString: string;
  responseJsonQuery?: TJsonQuery;
  mapPageOffersCount?: number;
}

function removeIdsFromJsonQuery(jsonQuery: TJsonQuery): TJsonQuery {
  const { ids: _ids, ...jsonQueryWithoutIds } = jsonQuery;

  return jsonQueryWithoutIds as TJsonQuery;
}

export const loadListingOffersByIds =
  ({
    baseJsonQuery,
    offerIds,
    queryString,
    responseJsonQuery,
    mapPageOffersCount,
  }: ILoadListingOffersByIdsArgs): TThunkAction<Promise<IPublicWebV1SearchResponse>> =>
  async (_dispatch, _getState, context) => {
    const { logger } = context;
    const jsonQueryToFetch = setTerms('ids')(baseJsonQuery)(offerIds);

    try {
      const result = await fetchListingOffers(context, {
        jsonQuery: jsonQueryToFetch,
        queryString,
      });

      return {
        ...result,
        jsonQuery: removeIdsFromJsonQuery((responseJsonQuery || result.jsonQuery) as TJsonQuery),
        offersCount: mapPageOffersCount ?? result.offersCount,
      };
    } catch (error) {
      logger.error(error);

      throw error;
    }
  };
